import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { TableRow, TableCell } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { setCardsSearchNoFetch, resetAll } from '@app/store/slices/cardsSlice';
import { setMyUsersParams } from '@app/store/slices/myUsersSlice';
import { CounterIcon, Status } from '@shared/ui/parts';
import { useMemberInfoDialog } from '@utils/dialogs-hooks';
import { getTotalCards } from '@utils/helpers';
import { theme } from '@utils/libs/theme';
import { membersColumns } from '@utils/tables/columns';
import { StatusCreatedAtCell } from '@widgets/tables/cells/common';
import {
  MemberActionCell,
  MemberCell,
  MemberContactCell,
  MemberName,
  MemberTeamsAvatar,
  MemberTeamsCell,
} from '@widgets/tables/cells/members';
import { CustomTable, CustomTableMobile } from '@widgets/tables/main';

export default function MembersTable() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { openMemberInfoDialog } = useMemberInfoDialog();
  const navigate = useNavigate();

  const { users, params, count_filtered, search, isLoading, isInitialized } =
    useSelector((state) => state.my_users);

  const handleSetParams = (newParams) => {
    dispatch(setMyUsersParams(newParams));
  };

  return isMobile ? (
    <CustomTableMobile
      params={params}
      setParams={handleSetParams}
      filteredCount={count_filtered || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      data={users}
    >
      {users?.map((row) => (
        <div
          onClick={() => openMemberInfoDialog(row)}
          key={row.id}
          className="tableMobile__list-item teamsMobile__item"
        >
          <MemberTeamsAvatar row={row} />
          <div className="teamsMobile__item-details">
            <MemberName row={row} />
            <div className="teamsMobile__item-counters">
              <CounterIcon icon="card-input" value={getTotalCards(row)} />
            </div>
          </div>
          <div className="teamsMobile__item-status align-start">
            <Status data={row} type="team" />
          </div>
        </div>
      ))}
    </CustomTableMobile>
  ) : (
    <CustomTable
      columns={membersColumns}
      data={users}
      filteredCount={count_filtered || 0}
      params={params}
      setParams={handleSetParams}
      search={search}
      isLoading={isLoading}
      isInitialized={isInitialized}
    >
      {users?.map((row) => (
        <TableRow tabIndex={-1} key={row.id}>
          <MemberCell row={row} />
          <MemberTeamsCell row={row} />
          <StatusCreatedAtCell row={row} type="team" />
          <MemberContactCell row={row} />
          <TableCell align="right">
            <button
              className="dashed-btn"
              onClick={() => {
                dispatch(resetAll());
                dispatch(setCardsSearchNoFetch(row.name));
                navigate('/cards');
              }}
            >
              <span className="fw-500">{getTotalCards(row)}</span>
            </button>
          </TableCell>
          <MemberActionCell row={row} />
        </TableRow>
      ))}
    </CustomTable>
  );
}
